import { fetchAuthSession } from 'aws-amplify/auth';

import AuthConfig from './AuthConfig';
import { markSessionExpired } from './lib/sessionExpiry';

let { isLogStdout } = AuthConfig;

let getAccessTokenInner = async () => {
  try {
    const { tokens } = await fetchAuthSession();
    if (!tokens) throw new Error('No tokens');
    return tokens.accessToken.toString();
  } catch (e) {
    markSessionExpired();
    throw e;
  }
};

let getAccessToken = async () => {
  return getAccessTokenInner();
};

let Auth_ = {
  getAccessToken,
  isLogStdout,
};

export default Auth_;
